export const membershipChipColor = (summary) => {
  if (!summary) return "default";
  switch (summary.eligibility) {
    case "eligible":
      return "success";
    case "grace":
      return "warning";
    case "late":
      return "error";
    default:
      return "default";
  }
};

export const membershipChipLabel = (summary) => summary?.label || "Sin membresía";

const formatIsoDay = (isoDate) => {
  const [year, month, day] = String(isoDate).split("-");
  return day && month && year ? `${day}/${month}/${year}` : isoDate;
};

export const membershipChipTooltip = (summary) => {
  if (summary?.eligibility !== "grace" || !summary.grace_ends_on) return "";
  return `Cuota vencida, en período de gracia hasta el ${formatIsoDay(summary.grace_ends_on)}`;
};

export const membershipStatusOptions = [
  { value: "active", label: "Activo" },
  { value: "suspended", label: "Suspendido" },
  { value: "deceased", label: "Fallecido" },
  { value: "banned", label: "Inhabilitado" },
];

/**
 * Index memberships by person id. Pass `personType` (class basename, e.g.
 * "RosterMember" or "OrganizationMember") to guard against id collisions
 * when the list could mix membershipable types.
 */
export const membershipByPersonId = (memberships = [], personType = null) => {
  const map = new Map();
  memberships.forEach((item) => {
    if (!item.membershipable_id) return;
    if (personType && item.membershipable_type !== personType) return;
    map.set(item.membershipable_id, item);
  });
  return map;
};

/** Display currency for amount fields (symbol when available, else ISO code). */
export const membershipUsesAnnualFee = (form = {}) => {
  const yearly = Number(form.membership_yearly_amount);
  return Number.isFinite(yearly) && yearly > 0;
};

export const isRevaAdminUser = (user) => Boolean(user?.is_reva_admin);

export const membershipCurrencySymbol = (currencyCode) => {
  if (!currencyCode) return "";
  try {
    const parts = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currencyCode,
      currencyDisplay: "narrowSymbol",
    }).formatToParts(0);
    return parts.find((part) => part.type === "currency")?.value || currencyCode;
  } catch {
    return currencyCode;
  }
};
